// FooterBox.tsx
import React, { ReactNode } from 'react';
import styles from './style.module.css';

type FooterBoxProps = {
  children: ReactNode;
  background?: string;
};

const FooterBox: React.FC<FooterBoxProps> = ({ children, background }) => {
  return (
    <div style={background ? {backgroundColor: background} : undefined} className={styles['main-holder']}>
      <div className={`container ${styles['container']}`}>
        <div className={styles['content']}>
          {children}
        </div>
      </div>
      <div className={styles['footer-box-main']}>

        
      </div>
    </div>

  );
};

export default FooterBox;
